import { render, staticRenderFns } from "./InformationItemList.vue?vue&type=template&id=4182115a&scoped=true&"
import script from "./InformationItemList.vue?vue&type=script&lang=js&"
export * from "./InformationItemList.vue?vue&type=script&lang=js&"
import style0 from "./InformationItemList.vue?vue&type=style&index=0&id=4182115a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4182115a",
  null
  
)

export default component.exports